import GlobalStyle from "GlobalStyle";
import React from "react";
import styled from "styled-components";
import { ReactComponent as Logo } from "../../../assets/img/Logo.svg";

function PreferenceManagementSuccess() {
  return (
    <Wrapper>
      <GlobalStyle />
      <div className="center-box">
        <CompanyLogo />
        <span className="text">Your subscription preferences have been successfully updated.</span>
        <div className="line-bottom">
          <p className="copyright-text">Copyright © 2022 xiQ Inc. All rights reserved.</p>
        </div>
      </div>
    </Wrapper>
  );
}

export default PreferenceManagementSuccess;

const Wrapper = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f8f6;
  .center-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    @media all and (max-width: 767px) {
      padding: 15px;
    }
  }
  .text {
    width: 558px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 32px;
    text-align: center;
    letter-spacing: -0.555556px;
    line-height: 35px;
    color: #5e7079;
    @media all and (max-width: 767px) {
      width: auto;
      font-size: 24px;
    }
  }
  .line-bottom {
    bottom: 0;
  }
  .copyright-text {
    width: 253px;
    height: 16px;
    font-family: "Roboto";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    letter-spacing: -0.555556px;
    color: #5e7079;
    opacity: 0.7;
    position: absolute;
    bottom: 0;
    left: 42%;
    @media all and (max-width: 767px) {
      left: 0;
      right: 0;
      white-space: nowrap;
      width: auto;
    }
  }
`;

const CompanyLogo = styled(Logo)`
  width: 111px;
  height: 58px;
  margin-bottom: 40px;
`;
